import Axios from 'axios';

import {
	STAFF_MINE_LOADING_TRUE,
	STAFF_MINE_LOADING_FALSE,
	STAFF_MINE_GET,
	STAFF_MINE_ERROR
} from './types';

export const staff_mine_loading_true = () => dispatch => {
	dispatch({
		type: STAFF_MINE_LOADING_TRUE
	})
}

export const staff_mine_loading_false = () => dispatch => {
	dispatch({
		type: STAFF_MINE_LOADING_FALSE
	})
}

export const get_staff_mine = () => dispatch => {
	dispatch(staff_mine_loading_true());

	let url = process.env.REACT_APP_SERVER_URL + '/api/staff/mine';

	process.env.REACT_APP_RUNTIME === 'Test' || process.env.REACT_APP_RUNTIME === 'Development'
		&& console.log('staff_mine url =', url);

	Axios.get(url)
	.then((res) => {
		dispatch({
			type: STAFF_MINE_GET,
			payload: res.data
		});
		
		dispatch(staff_mine_loading_false());
	}).catch((err) => {
		dispatch({
			type: STAFF_MINE_ERROR,
			payload: {type: 'staff_mine', msg: err.message}
		});

		dispatch(staff_mine_loading_false());
	})
}
